// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.popup-form {
  display: flex;
  flex-direction: column;
  margin-top: 15px;
}

.card-label {
  margin-bottom: 5px;
  font-size: 16px;
  font-weight: 400;
  line-height: 20.16px;
  color: #2f2f2f80;
  margin-bottom: 10px;
}

.card-value {
  margin-bottom: 20px;
  color: #052456;
  display: flex;
  width: 200px;
}

#card-number,
#card-holder {
  max-width: 320px;
}

#exp-month,
#exp-year {
  max-width: 59.5px;
}

.subtext {
  font-size: 13px;
  color: #052456;
  display: block;
  text-align: center;
}

.form-group-row {
  display: flex;
  justify-content: space-between;
  padding-right: 25px;
}

.small {
  flex: 1 1;
}

.small input::placeholder {
  display: flex;
  justify-content: center;
  align-items: center;
  padding-left: 6px;
}

.small:last-child {
  max-width: 74px;
  margin-right: 10px;
}
.view-attempts {
  padding: 0px 16px;
  margin-bottom: 15px;
}

.view-attempts h1 {
  font-size: 20px;
  font-weight: 600;
  line-height: 25.2px;
  text-align: left;
  margin-bottom: 8px;
}
.view-attempts p {
  font-size: 14px;
  font-weight: 400;
  line-height: 22px;
  text-align: left;
  margin-bottom: 24px;
  color: #54595e99;
}
.view-attempts-btn {
  display: flex;
  gap: 24px;
  justify-content: center;
}
.view-attempts-btn button {
  width: 180.5px;
}
.view-attempts-btn .accept {
  background: var(--orange);
}
.limit-reached {
  margin-top: 20px;
  margin-bottom: 10px;
}
.limit-count {
  padding-right: 30px;
  display: flex;
  justify-content: flex-end;
}
.limit-count p {
  border-radius: 40px;
  padding: 6px 12px;
  background: #f77c7c;
  color: var(--white);
  width: 137px;
  font-size: 11px;
  font-weight: 600;
  line-height: 13.86px;
  text-align: center;
}
`, "",{"version":3,"sources":["webpack://./src/components/cardPopup/cardPopup.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,aAAa;EACb,YAAY;AACd;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;;EAEE,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,SAAS;EACT,uBAAuB;AACzB;AACA;EACE,cAAc;AAChB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,mBAAmB;EACnB,aAAa;EACb,yBAAyB;AAC3B;AACA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,mBAAmB;EACnB,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,kBAAkB;AACpB","sourcesContent":[".popup-form {\n  display: flex;\n  flex-direction: column;\n  margin-top: 15px;\n}\n\n.card-label {\n  margin-bottom: 5px;\n  font-size: 16px;\n  font-weight: 400;\n  line-height: 20.16px;\n  color: #2f2f2f80;\n  margin-bottom: 10px;\n}\n\n.card-value {\n  margin-bottom: 20px;\n  color: #052456;\n  display: flex;\n  width: 200px;\n}\n\n#card-number,\n#card-holder {\n  max-width: 320px;\n}\n\n#exp-month,\n#exp-year {\n  max-width: 59.5px;\n}\n\n.subtext {\n  font-size: 13px;\n  color: #052456;\n  display: block;\n  text-align: center;\n}\n\n.form-group-row {\n  display: flex;\n  justify-content: space-between;\n  padding-right: 25px;\n}\n\n.small {\n  flex: 1;\n}\n\n.small input::placeholder {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  padding-left: 6px;\n}\n\n.small:last-child {\n  max-width: 74px;\n  margin-right: 10px;\n}\n.view-attempts {\n  padding: 0px 16px;\n  margin-bottom: 15px;\n}\n\n.view-attempts h1 {\n  font-size: 20px;\n  font-weight: 600;\n  line-height: 25.2px;\n  text-align: left;\n  margin-bottom: 8px;\n}\n.view-attempts p {\n  font-size: 14px;\n  font-weight: 400;\n  line-height: 22px;\n  text-align: left;\n  margin-bottom: 24px;\n  color: #54595e99;\n}\n.view-attempts-btn {\n  display: flex;\n  gap: 24px;\n  justify-content: center;\n}\n.view-attempts-btn button {\n  width: 180.5px;\n}\n.view-attempts-btn .accept {\n  background: var(--orange);\n}\n.limit-reached {\n  margin-top: 20px;\n  margin-bottom: 10px;\n}\n.limit-count {\n  padding-right: 30px;\n  display: flex;\n  justify-content: flex-end;\n}\n.limit-count p {\n  border-radius: 40px;\n  padding: 6px 12px;\n  background: #f77c7c;\n  color: var(--white);\n  width: 137px;\n  font-size: 11px;\n  font-weight: 600;\n  line-height: 13.86px;\n  text-align: center;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
